import React from 'react';
import { LocksmithLanding } from './pages/LocksmithLanding';
export function App() {
  return <LocksmithLanding data-id="element-0" />;
}